/* New Research Bids search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';

export interface ISearchFiltersNewResearchBidsState {
    bidDateRange: any;
    completionDateRange: any;
    fromBidDate: any;
    fromCompletionDate: any;
    toBidDate: any;
    toCompletionDate: any;
}

const defaultDateRangeValue = DateRanges.DateRangeOptionValues.LAST_THREE_MONTHS;
const initialState: ISearchFiltersNewResearchBidsState = {
    bidDateRange: DateRanges.DateRangeOptionValues.LAST_THREE_MONTHS,
    completionDateRange: DateRanges.DateRangeOptionValues.ALL_DATES,
    fromBidDate: DateRanges.getStartDate(defaultDateRangeValue),
    fromCompletionDate: '',
    toBidDate: DateRanges.getEndDate(defaultDateRangeValue),
    toCompletionDate: '',
};

export function searchFiltersNewResearchBidsReducer(state: ISearchFiltersNewResearchBidsState = initialState, action: any): ISearchFiltersNewResearchBidsState {
    switch (action.type) {
        case Actions.SEARCH_NEW_RESEARCH_BIDS_BID_DATE_RANGE:
            return _.merge({}, state, {
                bidDateRange: action.value,
                fromBidDate: DateRanges.getStartDate(action.value),
                toBidDate: DateRanges.getEndDate(action.value),
            });
        case Actions.SEARCH_NEW_RESEARCH_BIDS_FROM_BID_DATE:
            return _.merge({}, state, { fromBidDate: action.value });
        case Actions.SEARCH_NEW_RESEARCH_BIDS_TO_BID_DATE:
            return _.merge({}, state, { toBidDate: action.value });
        case Actions.SEARCH_NEW_RESEARCH_BIDS_COMPLETION_DATE_RANGE:
            return _.merge({}, state, {
                completionDateRange: action.value,
                fromCompletionDate: DateRanges.getStartDate(action.value),
                toCompletionDate: DateRanges.getEndDate(action.value),
            });
        case Actions.SEARCH_NEW_RESEARCH_BIDS_FROM_COMPLETION_DATE:
            return _.merge({}, state, { fromCompletionDate: action.value });
        case Actions.SEARCH_NEW_RESEARCH_BIDS_TO_COMPLETION_DATE:
            return _.merge({}, state, { toCompletionDate: action.value });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersNewResearchBidsReducer.tsx